import { FC } from "react"
import { CloudIcon as CI } from "@heroicons/react/20/solid"
import clsx from "clsx"

interface Props {
    enabled: boolean
}

const classes = {
    disabled: "text-gray-400",
    enabled: "text-primary-600",
}

const tickIcon = (
    <svg className="absolute inset-0 top-0.5 m-auto h-3 w-3 text-white" fill="currentColor" viewBox="0 0 12 12">
        <path d="M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" />
    </svg>
)

const crossIcon = (
    <svg className="absolute inset-0 top-0.5 m-auto h-3 w-3 text-white" fill="none" viewBox="0 0 12 12">
        <path
            d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const CloudIcon: FC<Props> = ({ enabled }) => {
    return (
        <div className="relative h-5 w-5">
            <CI
                className={clsx("absolute inset-0 h-full w-full", enabled ? classes.enabled : classes.disabled)}
                title={enabled ? "CloudSync enabled" : "CloudSync disabled"}
            />
            {enabled ? tickIcon : crossIcon}
        </div>
    )
}
